import React, { useState } from 'react'
import {
  TwoChildrenTemplate,
  SearchableLocalities,
  EmergencyCompaniesList,
  AddressAccessList,
} from 'components'
import { connect, useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import { Button } from 'sputnik-ui'
import { useTranslation } from 'react-i18next'
import { createAddressAccess } from 'store/operations'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100vw - (100vw - 100%));
  height: 90%;
`

function AddressAccessAdminPage({ userCompanyUuid, partnerCurrent, user }) {
  const [selectedLocalities, setSelectedLocalities] = useState([])
  const { t } = useTranslation('common')
  const dispatch = useDispatch()

  const handleLocalityChange = (value) => () => {
    const currentIndex = selectedLocalities.indexOf(value)
    const newSelected = [...selectedLocalities]

    if (currentIndex === -1) {
      newSelected.push(value)
    } else {
      newSelected.splice(currentIndex, 1)
    }

    setSelectedLocalities(newSelected)
  }

  const [selectedCompany, setSelectedCompany] = useState()

  const handleSubmit = () => {
    dispatch(
      createAddressAccess({
        company_uuid: selectedCompany,
        address_uuids: selectedLocalities,
      })
    )
  }

  return (
    <Wrapper>
      <TwoChildrenTemplate>
        <SearchableLocalities
          selected={selectedLocalities}
          handleLocalityChange={handleLocalityChange}
        />
        <EmergencyCompaniesList
          selected={selectedCompany}
          handleCompanyChange={setSelectedCompany}
        />
      </TwoChildrenTemplate>
      <Button
        variant="contained"
        color="primary"
        rounded
        type="submit"
        onClick={handleSubmit}
        disabled={!selectedCompany || selectedLocalities.length === 0}
      >
        {t('common:button.create')}
      </Button>
      <AddressAccessList selectedCompany={selectedCompany} />
    </Wrapper>
  )
}

const mapStateToProps = (state) => {
  const { auth, partners } = state

  return {
    userCompanyUuid: auth.user.company.uuid,
    dataCurrent: partners.current,
    user: auth.user,
  }
}

export default connect(mapStateToProps)(withRouter(AddressAccessAdminPage))
